/*
 * Summr: clicking a color dot on a product card swaps the card photo to that color's shirt,
 * and points the card's link at that color (so the product page opens on it too).
 * Dots are rendered by snippets/summr-color-dot.liquid with data-image-src / data-variant-id.
 */
(function () {
  if (window.__summrCardSwatches) return;
  window.__summrCardSwatches = true;

  function currentImage(card) {
    return (
      card.querySelector('.card-gallery slideshow-slide[aria-hidden="false"] img') ||
      card.querySelector('.card-gallery slideshow-slide:not([hidden]) img') ||
      card.querySelector('.card-gallery img')
    );
  }

  function selectDot(dot) {
    var wrap = dot.closest('.summr-swatches');
    var card = dot.closest('product-card') || dot.closest('.product-card');
    if (!wrap || !card) return;

    var src = dot.getAttribute('data-image-src');
    var srcset = dot.getAttribute('data-image-srcset');
    var variantId = dot.getAttribute('data-variant-id');
    var dots = Array.prototype.slice.call(wrap.querySelectorAll('.summr-swatch'));
    var index = dots.indexOf(dot);

    dots.forEach(function (d) {
      d.classList.toggle('is-selected', d === dot);
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });

    var img = currentImage(card);
    if (img && src) {
      img.removeAttribute('loading');
      if (srcset) {
        img.setAttribute('srcset', srcset);
      } else {
        img.removeAttribute('srcset');
      }
      img.setAttribute('src', src);
    }

    /* the card hover normally flips to the next photo; hold the chosen color while a non-default color is picked */
    card.setAttribute('data-summr-color', String(index));
    var gallery = card.querySelector('.card-gallery');
    if (gallery && !gallery.__summrHoverLock) {
      gallery.__summrHoverLock = true;
      gallery.addEventListener(
        'pointerenter',
        function (event) {
          if (card.getAttribute('data-summr-color') && card.getAttribute('data-summr-color') !== '0') {
            event.stopImmediatePropagation();
          }
        },
        true
      );
    }

    /* open the product page on this color */
    if (variantId) {
      Array.prototype.forEach.call(card.querySelectorAll('a[href*="/products/"]'), function (a) {
        var base = a.getAttribute('href').split('?')[0];
        a.setAttribute('href', base + '?variant=' + variantId);
      });
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var dot = event.target.closest && event.target.closest('.summr-swatch');
      if (!dot) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      selectDot(dot);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var dot = event.target.closest && event.target.closest('.summr-swatch');
      if (!dot) return;
      event.preventDefault();
      event.stopPropagation();
      selectDot(dot);
    },
    true
  );
})();
